import React from "react";

/**
 * Shared Sign Out control used by Command Center and Preferences.
 * Invokes the same onSignOut handler (App handleSignOut) in both places.
 */
export function SignOutButton({ onClick }) {
  if (!onClick) return null;

  return (
    <button
      type="button"
      className="cockpit-back-btn"
      onClick={onClick}
      style={{
        marginLeft: "auto",
        borderColor: "rgba(232,96,60,0.35)",
        color: "#ffb199",
      }}
    >
      Sign Out
    </button>
  );
}
